export const divingGear = [
  {
    id: 1,
    name: "ScubaPro Solar ",
    type: "mask",
    img: "../images/mask1.jpg",
    price: 250,
    manufacturer: "Scubapro",
    info: "The Scubapro Crystal Vu mask is a patented design that features seamless side windows for an excellent panoramic field of vision. The single lens construction with side panels provide exceptional field of vision while still being low in volume aiding quick and easy mask clearing. The high quality, super smooth silicone seal is specifically designed to be as supple as possible providing an excellent seal on a wide variety of face shapes while remaining comfortable even during prolonged periods of use. The buckles fitted to the side of the Crystal Vu are very easy to operate to the required fit for an excellent seal shortly after removing it from the supplied mask box.",
    inStock: true,
    inCart: false,
    color: "rose",
    age: "adult",
    featured: true,
    count: 0,
    total: 0,
    slug: "scubapro",
    features: [
      "Frameless",
      "170 degree view angle",
      "Metal buckles",
      "Low weight",
      "New  strap mounting",
    ],
  },
  {
    id: 2,
    name: "Interspiro MKII",
    type: "mask",
    img: "../images/mask2-e.png",
    price: 895,
    manufacturer: "Interspiro",
    info: "The Interspiro line of diving Full-Face Masks (FFMs) are high quality masks and have been field proven by Government, Military, and Commercial & Public Safety Teams around the world. The FFMs are primarily used with SCUBA, but are often utilized with surface supplied gas as well as rebreathers.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: true,
    count: 0,
    total: 0,
    slug: "interspiro",
    features: [
      "Face plate",
      "Automatic lens defogging",
      "Low pressure hose",
      "Internal oral/nasal mask",
      "Excellent for current diving",
      "High air flow capacity ",
    ],
  },
  {
    id: 3,
    name: "TecLine Frameless",
    type: "mask",
    img: "../images/mask3.jpg",
    price: 60,
    manufacturer: "Tecline",
    info: "A modern style mask with a black matt, shiny, soft and flexible silicone skirt to ensure a perfect fit to the face. The mask provides a large viewing angle and has a relatively small internal volume and the tempered divided glass. It makes mask from company TecLine popular masks in the world.",
    inStock: true,
    inCart: false,
    color: "yellow",
    age: "adult",
    featured: true,
    count: 0,
    total: 0,
    slug: "tecline-frameless",
    features: [
      "Patented single lens design",
      "Ultra-clear no-tint glass",
      "comfortable against the skin",
      "snug fit and ease of clearing.",
      "EZ-grab nose pocket",
    ],
  },
  {
    id: 4,
    name: "Cressi Calibro",
    type: "mask",
    img: "../images/mask4.png",
    price: 54,
    manufacturer: "Cressi",
    info: "CALIBRO provides a group of technical advantages that Cressi has been incorporating in the last seasons in different models. It combines a great technicality with a captivating design and medium dimensions, both of the frame and of the skirt. Its exclusive structure integrates the frame in the skirt instead of overlapping them. ",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "cressi-calibro",
    features: [
      "Low Profile",
      "Angled Lenses",
      "Micro Adjust Buckles",
      "snug fit and ease of clearing.",
      "EZ-grab nose pocket",
    ],
  },
  {
    id: 5,
    name: "Aqualung Reveal",
    type: "mask",
    img: "../images/mask5.png",
    price: 42,
    manufacturer: "Aqualung",
    info: "The AquaLung Reveal X2 Mask was made to be their most comfortable mask yet with many features to make it fit better. A premium mask the Reveal has super soft, crystal-clear silicone with a new ergonomic skirt. New buckles attach directly to the skirt for flexibility and have a quick single-button adjustment for the new spherical strap.",
    inStock: false,
    inCart: false,
    color: "yellow",
    age: "junior",
    featured: false,
    count: 0,
    total: 0,
    slug: "aqualung-reveal",
    features: [
      "SubFrame Design",
      "ARC Lenses",
      "Optical Grade Glass",
      "snug fit and ease of clearing.",
      "EZ-grab nose pocket",
    ],
  },
  {
    id: 6,
    name: "AquaLung Plasma",
    type: "mask",
    img: "../images/mask6.jpg",
    price: 90,
    manufacturer: "Aqualung",
    info: "The AquaLung Plasma Mask is one of the most comfortable masks on the market thanks to it's ExoHex Zones that maintain the shape and structure of the mask while reducing the pressure on your face. Any diver or snorkeller will appreciete the design and comfort of the mask skirt and curved strap.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "aqualung-plasma",
    features: [
      "Frameless construction using Aqua Lung's own micromask technology",
      "Quick fit buckles: The mechanism can be released with a single push of a button, allows for easy adjustment for a perfect fit - even with thick gloves.",
      "Optical Grade Glass and Leak-free frameless design",
      "The preformed mask strap adapts better to the diver's head for increased comfort and a secure fit.",
      "Advanced Fit Technology (AFT) improves the sealing properties and ensures a good fit, comfort and a comfortable fit.",
    ],
  },
  {
    id: 7,
    name: "Atomic Aquatics",
    type: "mask",
    img: "../images/mask7.png",
    price: 110,
    manufacturer: "Atomic Aquatics",
    info: "The Atomic Aquatics Frameless Midi Mask uses the same technology as the standard Frameless Mask but with a narrower skirt which is more suitable for ladies. The Atomic Frameless Midi Mask brings together a large single panel of 'UltraClear' glass with a shallow fit, low profile skirt to create an incredible field of vision. The high quality silicone skirt is bonded directly to the lens to eliminate the need for a bulky outer structural frame. The removal of the outer frame instantly maximises the peripheral vision and allows more light into the mask.",
    inStock: false,
    inCart: false,
    color: "blue",
    age: "junior",
    featured: false,
    count: 0,
    total: 0,
    slug: "atomic-aquatics",
    features: [
      "Leak-free frameless design",
      "Large viewing field",
      "Optical Grade Glass",
      "Low profile",
      "Clear or black silicone skirt",
    ],
  },
  {
    id: 8,
    name: "XDEEP",
    img: "../images/mask8.jpg",
    type: "mask",
    price: 65,
    manufacturer: "XDeep",
    info: "The XDEEP Frameless Mask is a large single lens dive mask with a soft silicone skirt and traditional strap. The frameless design brings the lens closer to your face so you get a wider FOV and less internal volume that you have to equalise and clear. The larger nose pocket makes the mask more comfortable and easier to equalise, even with thick gloves.",
    inStock: true,
    inCart: false,
    color: "blue",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "mask-xdeep",
    features: [
      "Equalise with ease",
      "Great Grip even in Thick Gloves",
      "Optical Grade Glass",
      "Pure colours with ultra clear glass",
      "Clear or black silicone skirt",
    ],
  },
  {
    id: 9,
    name: "Cressi Aqua",
    type: "fins",
    img: "../images/fins1.png",
    price: 32,
    manufacturer: "Cressi",
    info: "Agua is a very easy fin to use, and doesn’t require any special athletic or water-sport abilities, yet it still delivers excellent performance without tiring your feet. Thanks to the latest technology and Cressi’s experience in deve.",
    inStock: false,
    inCart: false,
    color: "yellow",
    age: "junior",
    featured: false,
    count: 0,
    total: 0,
    slug: "cressi-aqua",
    features: [
      "Long Blade",
      "Above Blade Foot Pocket",
      "Self Adjusting Foot Pocket",
    ],
  },
  {
    id: 10,
    name: "Aqualung Stratos",
    type: "fins",
    img: "../images/fins2.jpg",
    price: 39,
    manufacturer: "Aqualung",
    info: "Durable, light and affordable fin, ideal also for intensive use in Diving Centers. Stratos 3 passed the most extreme stress and anti-shock laboratory test. The best all-around full foot fins for diving. With the power for scuba diving and the sleek lines of a snorkeling fin, the Stratos 3 is an excellent choice for warm water.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "aqualung-stratos",
    features: [
      "Torsion Energy Point – a 3-materials side rib area that helps the blade flexing. The bending point has been moved backward, allowing more powerful kick with less efforts",
      "Ergonomic Foot Pocket – design and reinforced soft material allow a great comfort. The fin has to be worn bare foot or with sock",
      "Side wings enhance swim performance and stability",
      "Rubber side ribs in customized Aqua Lung compounds very elastic, robust, resilient, anti-scratch",
      "Anti-slip rubber pads improve stability on slippery floor",
    ],
  },
  {
    id: 11,
    name: "Spetton Ocean",
    type: "fins",
    img: "../images/fins3.jpg",
    price: 63,
    manufacturer: "Spetton",
    info: "The new fin is designed to improve performance with less effort, better power consumption and effortless transmission. The upper is made of thermo Resines and is joined with a comfortable shoe made of injected rubbers with shock resistant contours.",
    inStock: true,
    inCart: false,
    color: "blue",
    age: "adult",
    featured: true,
    count: 0,
    total: 0,
    slug: "spetton-ocean",
    features: [
      "It has a good response in depth and great swimming balance.",
      "Great Grip even in Thick Gloves",
      "Optical Grade Glass",
      "Pure colours with ultra clear glass",
      "Clear or black silicone skirt",
    ],
  },
  {
    id: 12,
    name: "SEAC Speed",
    type: "fins",
    img: "../images/fins4.jpg",
    price: 19,
    manufacturer: "Seac",
    info: "SEAC Speed Full Foot Lightweight Fins for Diving ,Snorkeling , Swimming. This high-tech fin designed specifically for snorkeling benefits from the best technologies used in free diving and scuba diving. Seacs unique molding process also allows for the use of three separate materials to create a highly-responsive blade.Now, snorkelers can power through current and enjoy hours on the water without undue muscle strain.",
    inStock: false,
    inCart: false,
    color: "green",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "seac-speed",
    features: [
      "Easy-kicking blade responds well to any kicking style.",
      "Great Grip even in Thick Gloves",
      "Optical Grade Glass",
      "Optimized ergonomic shape to obtain the best effortperformance ratio.",
      "Clear or black silicone skirt",
    ],
  },
  {
    id: 13,
    name: "APEKS XTX200",
    type: "regulator",
    img: "../images/regulator3.png",
    price: 449,
    manufacturer: "Apeks",
    info: "The XTX 200 is the flagship of the Apeks regulator range. A cold water rated, fully balanced primary regulator with environmental seal. The FSR first stage uses a balanced diaphragm design for high performance and air flow at any depth and cylinder pressure. Air is supplied via four low pressure and two high-pressure ports configured in easy hose routing positions.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "apeks-xtx200",
    features: [
      "Balanced diaphragm design first stage",
      "Environmentally sealed first stage",
      "Four low-pressure ports",
      "Two high-pressure ports",
      "Braided low-pressure hose",
    ],
  },
  {
    id: 14,
    name: "AQUALUNG LEG3ND",
    type: "regulator",
    img: "../images/regulator1.png",
    price: 15,
    manufacturer: "Aqualung",
    info: "The AquaLung Leg3nd MBS Stage 3 Regulator is a great all-rounder of a regulator for both cold water and travelling. The first stage is Environmentally Sealed and has large Heat-Sync Fins to improve performance in both warm and cold waters. The Legend MBS stands for Master Breathing System, which simply combines both Venturi and Breathing Effort into one knob.",
    inStock: false,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "aqualung-legend",
    features: [
      "OverBalanced - increases available gas the deeper you go.",
      "Auto-Closure Device - Closes the inlet to the 1st stage when depressurised to help prevent dust and water ingress",
      "Nitrox 40% Out of the Box",
    ],
  },
  {
    id: 15,
    name: "OCEANIC ALPHA",
    type: "regulator",
    img: "../images/regulator2.png",
    price: 129,
    manufacturer: "Oceanic",
    info: "The Oceanic Alpha 10 Octopus is a tough and simple octo made to compliment their range of regulators. Pneumatically balanced you'll get a steady flow of gas at any depth with a large purge button and a Venturi system that interrupts freeflows before they occur.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "oceanic-alpha",
    features: [
      "Valve Type Pneumatically balanced demand",
      "Mouthpiece Type Orthodontic w/ Bite Tabs",
      "Dimensions (Front Profile) 2.66 inch diameter (circular)",
      "Service Interval 2 Year, Required",
    ],
  },
  {
    id: 16,
    name: "SEAC P Synchro",
    type: "regulator",
    img: "../images/regulator4.png",
    price: 21,
    manufacturer: "Seac",
    info: "Designed for cold water dives. The new P-SYNCHRO diving regulation set , you can´t miss it. It is designed in two pieces that connect for optimal operation.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "seac-p-synchro",
    features: [
      "Valve Type Pneumatically balanced demand",
      "Mouthpiece Type Orthodontic w/ Bite Tabs",
      "Dimensions (Front Profile) 2.66 inch diameter (circular)",
      "Service Interval 2 Year, Required",
    ],
  },
  {
    id: 17,
    name: "SEAC Space",
    type: "suit",
    img: "../images/suit.png",
    price: 252,
    manufacturer: "Seac",
    info: "We bring you the new SPACE 5MM diving suit , made of ultra-elastic 5mm thick neoprene. It is a very easy and practical one-piece suit to put on. It is ideal to be used in high temperatures. It has a back zipper with an inner flap to ensure that water does not seep into the suit.",
    inStock: true,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "seac-space",
    features: [
      "High Warmth : Weight Ratio",
      "Quick Drying",
      "Anti-Microbial",
      "Thumb Loops",
      "Zippered Stretch Pocket",
    ],
  },
  {
    id: 18,
    name: "AQUALUNG THERMAL",
    type: "suit",
    img: "../images/suit2.png",
    price: 324,
    manufacturer: "Aqualung",
    info: "The AquaLung Thermal Fusion Undersuit is a warm unisex undersuit for your drysuit to keep you warm in the water.  With the same U-zip entry as the Fusion Drysuit Range and independent lab tests by SPIN the Thermal Fusion is proven to be comfortable and effective at keeping you warm in cold waters.",
    inStock: false,
    inCart: false,
    color: "black",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "aqualung-thermal",
    features: [
      "100g Thinsulate middle",
      "Breathable Ree-Tech outer",
      "Anti-Microbial",
      "Rip Stop nylon",
    ],
  },
  {
    id: 19,
    name: "Cressi Fast",
    type: "suit",
    img: "../images/suit3.png",
    price: 170,
    manufacturer: "Cressi",
    info: "The Cressi Fast Mens 3mm Wetsuit is a thinner suit for warmer waters where you don't need very much thermal protection but you do need something.  3mm is much more flexible and less buoyant than a 5mm so it won't feel as cumbersome or require as much lead to get down so your weight belt can be much lighter.",
    inStock: true,
    inCart: false,
    color: "orange",
    age: "adult",
    featured: true,
    count: 0,
    total: 0,
    slug: "cressi-fast",
    features: [
      "One-piece 3 mm wetsuit in double lined neoprene",
      "Ultraspan neoprene on arms and calves",
      "Pre-shaped legs",
      "Anti-abrasion reinforcement on the knees",
      "Wrists and ankles with water-stop system / watertight seals",
    ],
  },
  {
    id: 20,
    name: "Typhoon Quantum",
    type: "suit",
    img: "../images/suit4.png",
    price: 140,
    manufacturer: "Typhoon",
    info: "The Typhoon Quantum Air Drysuit is a tough neoprene drysuit that is made to be much lighter than other neoprene drysuits. Thigh pockets on each leg offer convenient storage and the blindstitched, taped seams ensure you stay dry for the whole dive.",
    inStock: true,
    inCart: false,
    color: "blue",
    age: "adult",
    featured: false,
    count: 0,
    total: 0,
    slug: "typhoon-quantum",
    features: [
      "HD Superflex 4mm Neoprene",
      "Armourtex Shell",
      "Glideskin Neoprene Seals",
      "Thermolined Boots",
      "Apeks Low Profile Valves",
    ],
  },
];

export const divingGearDetails = {
  id: 1,
  name: "ScubaPro Solar ",
  type: "mask",
  img: "../images/mask1.jpg",
  price: 250,
  manufacturer: "Scubapro",
  info: "The Scubapro Crystal Vu mask is a patented design that features seamless side windows for an excellent panoramic field of vision. The single lens construction with side panels provide exceptional field of vision while still being low in volume aiding quick and easy mask clearing. The high quality, super smooth silicone seal is specifically designed to be as supple as possible providing an excellent seal on a wide variety of face shapes while remaining comfortable even during prolonged periods of use. The buckles fitted to the side of the Crystal Vu are very easy to operate to the required fit for an excellent seal shortly after removing it from the supplied mask box.",
  inStock: true,
  inCart: false,
  color: "rose",
  age: "adult",
  featured: true,
  count: 0,
  total: 0,
  slug: "scubapro",
  features: [
    "Frameless",
    "170 degree view angle",
    "Metal buckles",
    "Low weight",
    "New  strap mounting",
  ],
};

/*
regulator2:
Photo by <a href="https://foter.co/a6/c04df9">Tim Patterson</a> on <a href="https://foter.com/re8/3fe6e5">Foter.com</a>
regulator3:
Photo by <a href="https://foter.co/a6/f9de52">Reef-World</a> on <a href="https://foter.com/re8/3fe6e5">Foter.com</a>
regulator4:
Photo by <a href="https://foter.co/a6/8b1471">avlxyz</a> on <a href="https://foter.com/re8/3fe6e5">Foter.com</a>
regulator5:
Photo by <a href="https://foter.co/a6/189bd1">D.Clow - Maryland</a> on <a href="https://foter.com/re8/3fe6e5">Foter.com</a>
*/
